module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', [_vm._v("Transaction Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  }) : _c('InputMask', {
    ref: "tran",
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "transactionDate"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "voucher"
    }
  }, [_vm._v("Voucher")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "voucher",
      "disabled": ""
    },
    model: {
      value: (_vm.voucherNo),
      callback: function($$v) {
        _vm.voucherNo = $$v
      },
      expression: "voucherNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('Checkbox', {
    attrs: {
      "id": "city1",
      "name": "city",
      "binary": true
    },
    model: {
      value: (_vm.isPdcTransaction),
      callback: function($$v) {
        _vm.isPdcTransaction = $$v
      },
      expression: "isPdcTransaction"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "city1"
    }
  }, [_vm._v("Pdc")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "account"
    }
  }, [_vm._v("Account")]), _vm._v(" "), _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filteredAccounts,
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      },
      "input": _vm.nepaliDate
    },
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 align-self-end"
  }, [_c('accountMasterDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Account'),
      expression: "'Add Account'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "btn-btm-0",
    on: {
      "set_account_master": _vm.set_account_master
    }
  })], 1), _vm._v(" "), (this.account.enableCostCenter) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('label', {
    attrs: {
      "for": "drAmount"
    }
  }, [_vm._v("Debit Amount")]), _vm._v(" "), (_vm.txnAmountCr > 0) ? _c('InputNumber', {
    attrs: {
      "id": "drAmount",
      "bodyStyle": "text-align: right",
      "minFractionDigits": 2,
      "maxFracionDigits": 4,
      "disabled": ""
    },
    model: {
      value: (_vm.txnAmountDr),
      callback: function($$v) {
        _vm.txnAmountDr = $$v
      },
      expression: "txnAmountDr"
    }
  }) : _c('InputNumber', {
    attrs: {
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "id": "drAmount",
      "bodyStyle": "text-align: right",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.txnAmountDr),
      callback: function($$v) {
        _vm.txnAmountDr = $$v
      },
      expression: "txnAmountDr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!this.account.enableCostCenter) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "drAmount"
    }
  }, [_vm._v("Debit Amount")]), _vm._v(" "), (_vm.txnAmountCr > 0) ? _c('InputNumber', {
    attrs: {
      "id": "drAmount",
      "bodyStyle": "text-align: right",
      "minFractionDigits": 2,
      "maxFracionDigits": 4,
      "disabled": ""
    },
    model: {
      value: (_vm.txnAmountDr),
      callback: function($$v) {
        _vm.txnAmountDr = $$v
      },
      expression: "txnAmountDr"
    }
  }) : _c('InputNumber', {
    attrs: {
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "id": "drAmount",
      "bodyStyle": "text-align: right",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.txnAmountDr),
      callback: function($$v) {
        _vm.txnAmountDr = $$v
      },
      expression: "txnAmountDr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!this.account.enableCostCenter) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "crAmount"
    }
  }, [_vm._v("Credit Amount")]), _vm._v(" "), (_vm.txnAmountDr > 0) ? _c('InputNumber', {
    attrs: {
      "id": "crAmount",
      "bodyStyle": "text-align: right",
      "minFractionDigits": 2,
      "maxFracionDigits": 4,
      "disabled": ""
    },
    model: {
      value: (_vm.txnAmountCr),
      callback: function($$v) {
        _vm.txnAmountCr = $$v
      },
      expression: "txnAmountCr"
    }
  }) : _c('InputNumber', {
    attrs: {
      "id": "crAmount",
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "bodyStyle": "text-align: right",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.txnAmountCr),
      callback: function($$v) {
        _vm.txnAmountCr = $$v
      },
      expression: "txnAmountCr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.account.enableCostCenter) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('label', {
    attrs: {
      "for": "crAmount"
    }
  }, [_vm._v("Credit Amount")]), _vm._v(" "), (_vm.txnAmountDr > 0) ? _c('InputNumber', {
    attrs: {
      "id": "crAmount",
      "bodyStyle": "text-align: right",
      "minFractionDigits": 2,
      "maxFracionDigits": 4,
      "disabled": ""
    },
    model: {
      value: (_vm.txnAmountCr),
      callback: function($$v) {
        _vm.txnAmountCr = $$v
      },
      expression: "txnAmountCr"
    }
  }) : _c('InputNumber', {
    attrs: {
      "id": "crAmount",
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "bodyStyle": "text-align: right",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.txnAmountCr),
      callback: function($$v) {
        _vm.txnAmountCr = $$v
      },
      expression: "txnAmountCr"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "shortNarr"
    }
  }, [_vm._v("Short Narration")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "shortNarr"
    },
    model: {
      value: (_vm.narration3),
      callback: function($$v) {
        _vm.narration3 = $$v
      },
      expression: "narration3"
    }
  })], 1), _vm._v(" "), (_vm.account.enableCostCenter) ? _c('div', {
    staticClass: "p-field p-mt-5 p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised ",
    attrs: {
      "label": "Cost Center"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openCostCenter.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.account.isBankAccount) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button p-component addNewBtn btn-btm-0",
    attrs: {
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTransactionToDTO.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.account.isBankAccount) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editDTO),
      expression: "editDTO"
    }],
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetAccountDto.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [(_vm.account.closingBalance >= 0 || _vm.account.closingBalance < 0) ? _c('label', [_vm._v("Cur. Bal:")]) : _vm._e(), _vm._v(" "), (_vm.account.closingBalance > 0) ? _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s((_vm.account.closingBalance).toFixed(2) + ' ' + 'Cr'))]) : (_vm.account.closingBalance === 0) ? _c('b', [_vm._v("\n              " + _vm._s((_vm.account.closingBalance).toFixed(2)) + "\n            ")]) : (_vm.account.closingBalance < 0) ? _c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n              " + _vm._s((_vm.account.closingBalance).toFixed(2) * (-1) + ' ' + 'Dr') + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.account.isBankAccount),
      expression: "account.isBankAccount"
    }],
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', [_vm._v("Cheque Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.chequeDate),
      callback: function($$v) {
        _vm.chequeDate = $$v
      },
      expression: "chequeDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "chequeDate"
    },
    model: {
      value: (_vm.chequeDate),
      callback: function($$v) {
        _vm.chequeDate = $$v
      },
      expression: "chequeDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.account.isBankAccount),
      expression: "account.isBankAccount"
    }],
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "chequeNo"
    }
  }, [_vm._v("Cheque No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "chequeNo"
    },
    model: {
      value: (_vm.chequeNumber),
      callback: function($$v) {
        _vm.chequeNumber = $$v
      },
      expression: "chequeNumber"
    }
  })], 1), _vm._v(" "), (_vm.account.isBankAccount) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "type": "submit",
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTransactionToDTO.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.account.isBankAccount) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editDTO),
      expression: "editDTO"
    }],
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetAccountDto.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', [_c('div', {
    staticClass: "jouscroll"
  }, [_c('table', {
    staticClass: "table table-bordered "
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.transactionDetailDTOList), function(account, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.accountMaster.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.drCr == 'D' ? account.txnAmount : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.drCr == 'C' ? account.txnAmount : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.chequeDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.chequeNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.narration3))]), _vm._v(" "), (account.accountMaster.isBankAccount === false && account.accountMaster.isCashAccount === false) ? _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-info",
      attrs: {
        "label": "Bill detail"
      },
      on: {
        "click": _vm.billDetailDialog
      }
    })], 1) : _c('td'), _vm._v(" "), (!account.enableCostCenter) ? _c('td', [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.viewCostCenterDialog(account)
        }
      }
    }, [_vm._v("Cost Center")])]) : _vm._e(), _vm._v(" "), _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          return _vm.editAccountFromDTO(account, index)
        }
      }
    }), _vm._v(" "), _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAccountFromDTO(account, index)
        }
      }
    })], 1)])])
  }), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.drtotal.toFixed(4)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.crTotal.toFixed(4)))]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Diff Amt:")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(_vm.calculation === 0) ? _c('span', {
    staticStyle: {
      "margin-left": "2em",
      "color": "green",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.calculation.toFixed(4)))]) : _c('span', {
    staticStyle: {
      "margin-left": "2em",
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.calculation.toFixed(4)))])])])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "narration1"
    }
  }, [_vm._v("Narration")]), _vm._v(" "), _c('TextArea', {
    attrs: {
      "cols": "15",
      "rows": "6",
      "id": "narration1"
    },
    model: {
      value: (_vm.narration),
      callback: function($$v) {
        _vm.narration = $$v
      },
      expression: "narration"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', [_vm._v("Paid By")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "receivedBy"
    },
    model: {
      value: (_vm.receivedBy),
      callback: function($$v) {
        _vm.receivedBy = $$v
      },
      expression: "receivedBy"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-pt-6"
  }, [(this.receipt != undefined) ? _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "type": "submit",
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-pt-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-warning",
    attrs: {
      "icon": "pi pi-refresh",
      "label": "Reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-pt-6"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "icon": "pi pi-save",
      "label": !_vm.editing ? 'Save' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveReceiptEntry.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-pt-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-info",
    attrs: {
      "icon": "pi pi-print",
      "label": "Print"
    },
    on: {
      "click": function($event) {
        return _vm.openVoucher()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-pt-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-download",
      "label": "Generate PDF"
    }
  })], 1)])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '60vw'
    }),
    attrs: {
      "header": "Sales Bill List",
      "visible": _vm.billDialog,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'auto'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.billDialog = $event
      }
    }
  }, [_c('form', [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.inOutHeaderDTOList,
      "paginator": true,
      "rows": 8
    }
  }, [_c('Column', {
    attrs: {
      "field": "purchaseSalesDate",
      "header": "Date",
      "headerStyle": "width:10em"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "purchaseSalesDateNepali",
      "headerStyle": "width:10em",
      "header": "Nepali Date"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "billNo",
      "header": "Bill No"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "totalBillAmount",
      "header": "Bill Amount"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "",
      "header": "Due Amount"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v(_vm._s(slotProps.data.totalBillAmount - slotProps.data.cashPaidReceived) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "remarks",
      "header": "Remarks"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": " Amount",
      "headerStyle": "width:10em",
      "field": "amountTobeDeduct"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (slotProps.data[slotProps.column.field]),
            expression: "slotProps.data[slotProps.column.field]"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (slotProps.data[slotProps.column.field])
          },
          on: {
            "change": function($event) {
              return _vm.checkAmountEntered(slotProps.data)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(slotProps.data, slotProps.column.field, $event.target.value)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeBillDialog.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '60vw'
    }),
    attrs: {
      "header": "Cost Center",
      "visible": _vm.costCenterDialog,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.costCenterDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": "Save"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCostCenter.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancelCostCenter.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.costCenterList,
      "paginator": true,
      "rows": 5
    }
  }, [_c('Column', {
    attrs: {
      "header": "Name",
      "field": "costCenter"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [(_vm.viewCostCenter) ? _c('Dropdown', {
          attrs: {
            "options": _vm.costCenterForTransactionLists,
            "optionLabel": "name",
            "disabled": "",
            "placeholder": "Select One",
            "filter": true
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        }) : _c('Dropdown', {
          attrs: {
            "options": _vm.costCenterForTransactionLists,
            "optionLabel": "name",
            "placeholder": "Select One",
            "filter": true
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })], 1)])]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Amount",
      "field": "costCenterAmt"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.viewCostCenter) ? _c('InputNumber', {
          attrs: {
            "disabled": "",
            "mode": "decimal",
            "locale": "en-IN",
            "minFractionDigits": 2
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        }) : _c('InputNumber', {
          attrs: {
            "mode": "decimal",
            "locale": "en-IN",
            "minFractionDigits": 2
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }])
  }), _vm._v(" "), (!_vm.viewCostCenter) ? _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "icon": "pi pi-plus"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addToCostCenterList()
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-minus"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.subCostCenterList(slotProps.index)
            }
          }
        })]
      }
    }], null, false, 1195948385)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Account Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Debit Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Credit Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Cheque Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Cheque Number")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Short Narration")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Bills Detail\n                ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Cost Center")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Action")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80a28ca4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/accounting/receipt.vue
// module id = 2351
// module chunks = 0